/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { OnlineMeetingEntry } from '../../Model/Explore/OnlineMeetingEntry';
import { OfflineMeetingEntry } from '../../Model/Explore/OfflineMeetingEntry';
import { ArticleEntry } from '../../Model/Explore/ArticleEntry';
import { ExploreContentViewOnlineMeeting } from './ExploreContentViewOnlineMeeting/ExploreContentViewOnlineMeeting';
import { ExploreContentViewOfflineMeeting } from './ExploreContentViewOfflineMeeting/ExploreContentViewOfflineMeeting';
import { ExploreContentViewArticle } from './ExploreContentViewArticle/ExploreContentViewArticle';
import { ActivityWorkoutEntry } from '../../Model/Explore/ActivityWorkoutEntry';
import { ExploreContentViewActivityWorkout } from './ExploreContentViewActivityWorkout/ExploreContentViewActivityWorkout';
import { WebinarEntry } from '../../Model/Explore/WebinarEntry';
import { ExploreContentViewWebinar } from './ExploreContentViewWebinar/ExploreContentViewWebinar';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';
import { ExploreContentViewRecipe } from './ExploreContentViewRecipe/ExploreContentViewRecipe';
import { MeditationEntry } from '../../Model/Explore/MeditationEntry';
import { ExploreContentViewMeditation } from './ExploreContentViewMeditation/ExploreContentViewMeditation';
import { BreathingEntry } from '../../Model/Explore/BreathingEntry';
import { ExploreContentViewBreathing } from './ExploreContentViewBreathing/ExploreContentViewBreathing';
import { ExploreContentViewWorkoutTemplate } from './ExploreContentViewWorkoutTemplate/ExploreContentViewWorkoutTemplate';
import { WorkoutTemplateEntry } from '../../Model/Explore/WorkoutTemplateEntry';
import { ScheduleButtonProps } from '../ScheduleButton';
import { EventEntry } from '../../Model/Coach/Schedule/EventEntry';
import { KinasticContent } from '../../Model/Explore/ExploreContentBuilder';

export type ExploreContentViewRendererProps = ScheduleButtonProps & {
  entry: KinasticContent;
  parentEvent?: EventEntry;
  selectedEvent?: EventEntry;
};

export const ExploreContentViewRenderer: React.FC<ExploreContentViewRendererProps> = observer(
  ({ entry, ...moreProps }) => {
    if (entry.type === 'onlineMeeting') {
      return <ExploreContentViewOnlineMeeting entry={entry as OnlineMeetingEntry} />;
    } else if (entry.type === 'offlineMeeting') {
      return <ExploreContentViewOfflineMeeting entry={entry as OfflineMeetingEntry} />;
    } else if (entry.type === 'article') {
      return <ExploreContentViewArticle entry={entry as ArticleEntry} />;
    } else if (entry.type === 'meditation') {
      return <ExploreContentViewMeditation entry={entry as MeditationEntry} />;
    } else if (entry.type === 'activityWorkout') {
      return <ExploreContentViewActivityWorkout entry={entry as ActivityWorkoutEntry} />;
    } else if (entry.type === 'webinar') {
      return <ExploreContentViewWebinar entry={entry as WebinarEntry} />;
    } else if (entry.type === 'recipe') {
      return <ExploreContentViewRecipe entry={entry as Recipe} />;
    } else if (entry.type === 'breathing') {
      return <ExploreContentViewBreathing entry={entry as BreathingEntry} />;
    } else if (entry.type === 'workoutTemplate') {
      return <ExploreContentViewWorkoutTemplate entry={entry as WorkoutTemplateEntry} {...moreProps} />;
    }

    return null;
  },
);
